// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"364f14b3","129":"7bffe68a","197":"02a29e61","618":"fe3bda1d","725":"03edbf07","992":"9f3587cc"}[chunkId] + ".chunk.js";
};